module.exports = __webpack_public_path__ + "static/media/full_screen.b7bf9a36.svg";